(function() {
 
  const menu = document.querySelector(".menu-draggable");
  const btnArrowLeft = document.querySelector(".btn-arrow.left");
  const btnArrowRight = document.querySelector(".btn-arrow.right");

  window.addEventListener("resize", updateArrowButtons);
  menu.addEventListener("scroll", updateArrowButtons);
  
  function updateArrowButtons() {
    btnArrowLeft.classList.toggle("hidden", menu.scrollLeft === 0);
    btnArrowRight.classList.toggle(
      "hidden",
      menu.scrollLeft + menu.clientWidth >= menu.scrollWidth,
    );
  }

  btnArrowLeft.addEventListener("click", () => {
    menu.scrollBy({
      left: -300,
      behavior: "smooth",
    });
    updateArrowButtons();
  });

  btnArrowRight.addEventListener("click", () => {
    menu.scrollBy({
      left: 300,
      behavior: "smooth",
    });
    updateArrowButtons();
  });

  document.addEventListener("DOMContentLoaded", function() {
    updateArrowButtons();
  });
})()
